import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CompanyLocationDto } from '@bo-client/shared/models/companyLocations';
import { FeedInManagementInfoEnum } from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';
import { uri } from '@bo-client/shared/constants/uri';
import { combineLatestWith, takeUntil, tap } from 'rxjs/operators';
import { HttpHapService } from '@bo-client/core/http/http-hap.service';
import { Subject } from 'rxjs';
import { PVModuleModel } from '@bo-client/activation-management/grid-registration/model/pv-module.model';
import { ProducerModel } from '@bo-client/activation-management/grid-registration/model/producer.model';
import { NBPConfig } from '@bo-client/shared/config.model';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { FeedInManagementModel } from '@bo-client/activation-management/grid-registration/model/feedInManagementModel';

@Component({
  selector: 'app-feedin-management-summary',
  templateUrl: './feedin-management-summary.component.html',
  styleUrls: ['../../../../../../shared/summaries/css-summary.component.scss']
})
export class FeedinManagementSummaryComponent implements OnInit, OnDestroy {
  @Input() companyLocation: CompanyLocationDto;
  @Input() feedInManagementInfo: FeedInManagementInfoEnum;
  @Input() producers: ProducerModel[];
  @Input() showConfirmationBody?: boolean;
  @Input() pvModules: PVModuleModel[];
  @Input() totalPower: number | null; // this is alternative to producers/pvModules

  private compUnsubs$ = new Subject<void>();
  public dataToShow: any = null;
  public MwSt = 19;

  constructor(private httpHapService: HttpHapService, private dataShareService: DataShareService) {}

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.httpHapService
      .getTyped<FeedInManagementModel[]>(
        uri.cmGridRegistrationFeedInManagementPrices + '/' + this.companyLocation.external_id
      )
      .pipe(
        takeUntil(this.compUnsubs$),
        combineLatestWith(this.dataShareService.tenantConfig$),
        tap(([companyLocations, nbpConfig]) => {
          this.loadValueToShow(companyLocations, nbpConfig);
        })
      )
      .subscribe({
        error: (err) => {
          console.log(err);
        }
      });
  }

  loadValueToShow(preisList: FeedInManagementModel[], nbpConfig: NBPConfig) {
    let totalPower = this.totalPower || 0;
    if (this.pvModules && this.pvModules.length > 0) {
      totalPower = this.pvModules.reduce((sum, x) => sum + (x.count * x.modulePowerWatt) / 1000, 0);
    } else if (this.producers && this.producers.length > 0) {
      totalPower = this.producers.reduce((sum, x) => sum + x.count * x.acActivePowerMax, 0);
    }
    if (totalPower == 0) {
      return;
    }
    const idxPreis = preisList.findIndex(
      (optPrice) => optPrice.feedInManagementInfo == this.feedInManagementInfo
    );
    this.dataToShow = preisList[idxPreis];
    const feedInfos = nbpConfig.gridRegistration.feedInManagement.filter(
      (ele) => ele.value == this.feedInManagementInfo
    );
    if (!feedInfos || feedInfos.length == 0) {
      return;
    }
    this.dataToShow.optionTitle = feedInfos[0].optionTitle;
    this.dataToShow.optionDescription = feedInfos[0].optionDescription;
    // @ts-ignore
    const titleList = nbpConfig.gridRegistration.feedInManagement.filter(
      (ele) => ele.minPower <= totalPower && totalPower < ele.maxPower
    );
    if (titleList) {
      this.dataToShow.title = titleList[0].title;
      this.dataToShow.titleDescription = titleList[0].titleDescription;
    }
  }

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
